import { Subscription } from "rxjs";
import { DownloadState } from "./download-state";

export class Download {
  id: string;
  subscription: Subscription;
  pending = true;
  finished = false;
  currentState?: DownloadState;

  constructor(id: string, subscription?: Subscription) {
    this.id = id;
    this.subscription = subscription;
  }

  canDownload():boolean {
    return !this.currentState && !this.pending && !this.finished;
  }
}
